function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.77485 12.2734H4.44485C3.433 12.2761 2.45978 12.6622 1.72125 13.3539C0.982724 14.0456 0.533772 14.9914 0.464844 16.0009H12.7549C12.6859 14.9914 12.237 14.0456 11.4984 13.3539C10.7599 12.6622 9.78669 12.2761 8.77485 12.2734V12.2734Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.22 2.67L6.61 0L0 2.67L6.61 5.3425L12.6725 2.8925V6.8925C12.679 6.96059 12.7107 7.02381 12.7613 7.06982C12.8119 7.11582 12.8779 7.14131 12.9463 7.14131C13.0147 7.14131 13.0806 7.11582 13.1312 7.06982C13.1818 7.02381 13.2135 6.96059 13.22 6.8925V2.67Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4451 7.41406C10.4463 6.49673 10.1633 5.60154 9.6351 4.85156L6.61009 6.07156L3.58759 4.85156C3.05936 5.60154 2.77639 6.49673 2.77759 7.41406C2.77509 9.74906 4.49259 11.6266 6.61009 11.6266C8.7276 11.6266 10.4451 9.74906 10.4451 7.41406Z",
  fill: "currentColor"
});

function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.d1d47ce6.svg";
export { ForwardRef as ReactComponent };